import Section from "@packages/sections/section";
import TooltipExtension from "@/extensions/tooltips";

class ControlKitBuilderNewSection extends Section {
    extensions() {
        return [
            ...super.extensions(),
            TooltipExtension,
        ];
    }
}

export default ControlKitBuilderNewSection;
